export default __webpack_public_path__ + "images/plans_bg.png";